import { createContext } from "react-router"
import type { TUtcDateTime } from "../shared/types"

export const appTimeContext = createContext<TUtcDateTime>()
